<template>
  <div class="w-full flex flex-col bg-white rounded-r-lg">
    <div class="p-3 sm:p-6 !pb-0">
      <div class="text-2xl sm:text-3xl font-bold mb-2">Choose a Package</div>
    </div>
    <div
      class="flex-1 overflow-y-auto p-3 sm:p-6"
      v-if="proposal"
    >
      <div
        :class="{
          'grid gap-6 overflow-x-auto': true,
          'grid-cols-3 min-w-[calc(200px*3+3rem)]': proposal.packages.length === 3,
          'grid-cols-2 min-w-[calc(180px*2+1.5rem)]': proposal.packages.length === 2,
          'grid-cols-1 min-w-[160px]': proposal.packages.length === 1,
        }"
        :style="{
          'grid-template-rows': `repeat(${subGridRows}, auto)`,
        }"
      >
        <portal-billing-proposal-package-card
          v-for="(pkg, index) in proposal.packages"
          :key="index"
          :pkg="pkg"
          @set-selected-package="$emit('set-selected-package', $event)"
          :is-selected="pkg?.id === selectedPackage?.id"
          :package-selected-by-other="proposal.packages.some((pkg) => pkg.selected)"
          :sub-grid-rows="subGridRows"
        />
        <!--  @set-package-selected="" -->
      </div>
    </div>
  </div>
</template>
<script>
import PortalBillingProposalPackageCard from "./PortalBillingProposalPackageCard.vue"

export default {
  name: "PortalBillingProposalPackages",
  components: {
    PortalBillingProposalPackageCard,
  },
  emits: ["set-selected-package"],
  props: {
    selectedPackage: {
      type: Object,
    },
  },
  data() {
    return {
      proposal: window.FinancialCents?.proposal,
    }
  },
  computed: {
    subGridRows() {
      if (!this.proposal?.packages?.length) return 2

      // Calculate the maximum number of sections across all packages
      let maxRows = 0
      this.proposal.packages.forEach((pkg) => {
        let rowCount = 1 // Start with 1 for the header/button section

        pkg.sections.forEach((section) => {
          if (section.frequency === "deposit") {
            rowCount += 2 // Deposit frequency creates 2 rows (deposit + balance)
          } else {
            rowCount += 1 // Regular section creates 1 row
          }
        })

        maxRows = Math.max(maxRows, rowCount)
      })

      return maxRows
    },
  },
}
</script>
